"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * AssertNever is a utility function that can be used for exhaustiveness checks in switch statements.
 *
 * @public
 */
function assertNever(x) {
    throw new Error('Unexpected object: ' + x);
}
exports.assertNever = assertNever;
//# sourceMappingURL=assertNever.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/utilities/lib/assertNever.js
// module id = 274
// module chunks = 0